import { breakpoints } from '../Breakpoints'
import { space } from '../Core'
import { fonts, pixelToRemMap } from '../Typography'
import { ComponentsOverrides } from '@mui/material/styles'
import { applyAlpha } from '../utils/utils'

const generateVariantStyles = (
  bgColor: string,
  textColor: string,
  hoverBgColor: string,
  activeBgColor: string,
  disabledBgColor: string,
  disabledTextColor: string,
  shadowColor: string
) => ({
  boxShadow: shadowColor ? `${applyAlpha(shadowColor, 0.35)} 0px 4px 14px 0px` : 'none !important',
  backgroundColor: bgColor,
  color: textColor,
  '&:hover': {
    boxShadow: shadowColor ? `${applyAlpha(shadowColor, 0.35)} 0px 4px 14px 0px` : 'none !important',
    backgroundColor: hoverBgColor
  },
  '&:active': {
    boxShadow: shadowColor ? `${applyAlpha(shadowColor, 0.35)} 0px 4px 14px 0px` : 'none !important',
    backgroundColor: `${activeBgColor} !important`,
    border: `none`
  },
  '&.Mui-disabled': {
    boxShadow: 'none !important',
    backgroundColor: `${disabledBgColor} !important`,
    color: disabledTextColor
  }
})

export const createMuiButtonOverrides = (selectedPalette: any): ComponentsOverrides['MuiButton'] => ({
  root: () => ({
    borderRadius: '100px',
    width: '100%',
    textTransform: 'none',
    minHeight: pixelToRemMap[58],
    minWidth: pixelToRemMap[280],
    padding: `${space.spacing[5]}px  ${space.spacing[10]}px !important`,
    fontWeight: 500,
    fontFamily: fonts.medium,
    letterSpacing: '0.3px',
    fontSize: pixelToRemMap[18],
    lineHeight: pixelToRemMap[26],
    cursor: 'pointer',
    [breakpoints.up('sm')]: { minWidth: pixelToRemMap[326] }
  }),
  contained: () => ({
    '&.MuiButton-containedPrimary, &.MuiButton-containedSecondary': generateVariantStyles(
      selectedPalette.primary[40], // backgroundColor
      selectedPalette.primary[100], // text color
      selectedPalette.primary[20], // hover backgroundColor
      selectedPalette.primary[20], // active backgroundColor
      selectedPalette.neutral[80], // disabled backgroundColor
      selectedPalette.neutral[100], // disabled text color
      selectedPalette.primary[50] // shadow color
    )
  }),
  outlined: () => ({
    '&.MuiButton-outlinedPrimary, &.MuiButton-outlinedSecondary': {
      border: `1px solid ${selectedPalette.primary[40]}`,
      color: selectedPalette.primary[40],
      backgroundColor: 'transparent',
      '&:hover, &:active': {
        backgroundColor: 'transparent !important',
        color: selectedPalette.primary[30],
        border: `2px solid ${selectedPalette.primary[30]}`
      },
      '&:disabled': {
        backgroundColor: 'transparent !important',
        color: selectedPalette.neutral[80],
        border: `1px solid ${selectedPalette.neutral[80]}`
      }
    }
  }),
  text: () => ({
    '.MuiTouchRipple-root span': { display: 'none' },
    '&.MuiButton-textPrimary, &.MuiButton-textSecondary': {
      border: 'none',
      backgroundColor: 'transparent',
      color: selectedPalette.neutral[40],
      '&:hover, &:active': {
        backgroundColor: 'transparent',
        color: selectedPalette.primary[30],
        border: 'none'
      },
      '&:disabled': {
        backgroundColor: 'transparent',
        color: selectedPalette.neutral[60],
        border: 'none'
      }
    }
  })
})